import { tierLabel } from '../terms/tiers';
export function formatPlayerWithdrawalUsd(n) {
    if (n == null || !Number.isFinite(Number(n)))
        return '—';
    return `$${Number(n).toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 2 })}`;
}
export function playerWithdrawalLevelLabel(level) {
    return tierLabel(level) || 'Shop';
}
const LEVEL_ORDER = [
    'shop',
    'agent',
    'super_agent',
    'platform',
];
export function playerWithdrawalChainRows(snapshot, viewerLevel) {
    const start = LEVEL_ORDER.indexOf(viewerLevel);
    return snapshot.chain
        .filter((item) => LEVEL_ORDER.indexOf(item.level) >= start)
        .map((item) => {
        const isViewer = item.level === viewerLevel;
        const inherited = item.level !== 'platform' && item.override == null;
        return {
            level: item.level,
            label: isViewer ? 'This account' : playerWithdrawalLevelLabel(item.level),
            valueText: inherited ? 'Inherit' : formatPlayerWithdrawalUsd(item.override),
            applied: item.level === snapshot.source,
        };
    });
}
export function playerWithdrawalChainSummary(snapshot) {
    return snapshot.chain
        .map((item) => {
        if (item.level === 'platform') {
            return `Platform ${formatPlayerWithdrawalUsd(item.override)}`;
        }
        const value = item.override == null ? 'inherit' : formatPlayerWithdrawalUsd(item.override);
        return `${playerWithdrawalLevelLabel(item.level)} ${value}`;
    })
        .join(' · ');
}
export function playerWithdrawalSourceLabel(snapshot, viewerLevel) {
    const inheriting = snapshot.override == null;
    const sourceLabel = snapshot.source === viewerLevel
        ? 'Set for this account'
        : snapshot.source === 'platform'
            ? 'Using the Platform default'
            : `Inherited from ${playerWithdrawalLevelLabel(snapshot.source)}`;
    return `${sourceLabel}${inheriting ? ' (not overridden here)' : ''}.`;
}
